import { BaseRepository } from '@/src/api/BaseRepository'
import { AllWidgetsResponseData, CreateWidgetRequestData, CreateWidgetResponseData, GetWidgetResponseData } from '@/src/api/WidgetRepository.types'
import { CSRF } from '@/src/utils/CSRF'

export default class WidgetRepository extends BaseRepository {
  getWidget = async (uuid: string) => {
    return (
      await super.getHttpClientInstance().get<GetWidgetResponseData>(`/api/v2/widgets/${uuid}`, {
        'X-CSRF-Token': CSRF.getToken(),
        'Content-Type': 'application/json',
      })
    ).data
  }

  getAllWidgets = async () => {
    return (
      await super.getHttpClientInstance().get<AllWidgetsResponseData>('/api/v2/widgets', {
        'X-CSRF-Token': CSRF.getToken(),
        'Content-Type': 'application/json',
      })
    ).data
  }

  createWidget = async (widgetRequestData: CreateWidgetRequestData) => {
    return (
      await super.getHttpClientInstance().post<CreateWidgetResponseData>('/api/v2/widgets', widgetRequestData, {
        'X-CSRF-Token': CSRF.getToken(),
        'Content-Type': 'application/json',
      })
    ).data
  }

  deleteWidget = async (uuid: string) => {
    return (
      await super.getHttpClientInstance().delete(`/api/v2/widgets/${uuid}`, {
        'X-CSRF-Token': CSRF.getToken(),
        'Content-Type': 'application/json',
      })
    ).data
  }
}
